export const ANNUAL_REPORT_AUDITOR_STEP_SIGNED = "ANNUAL_REPORT_AUDITOR_STEP_SIGNED";